<template>
  <div class="evaluate-result-model">
    <div class="comment-success">
      <img src="../../assets/imgs/icon-comment-success.svg" />
      提交成功
    </div>
    <template v-if="isOpenSolveButton">
      <div v-if="isSolve" class="solved-button">
        <img src="../../assets/imgs/icon-comment-shang-active.png" />
        已解决
      </div>
      <div v-else class="no-solved-button">
        <img src="../../assets/imgs/icon-comment-xia-active.png" />
        未解决
      </div>
    </template>
    <el-rate class="icon_rate" v-model="rate" :disabled="true" />
    <span class="comment-text">{{ evaluateStarName }}</span>
    <template v-if="!isFiveRate">
      <div class="comment-btns">
        <div v-for="s in tags" :key="s">{{ s }}</div>
      </div>
      <div class="comment-content">
        <u class="pre">{{ evaluateContent }}</u>
      </div>
    </template>
  </div>
</template>

<script>
//用户评论结果弹窗
export default {
  computed: {
    ...mapState({
      evaluateResult: state => state.evaluateResult, //评论结果
      evaluateConfig: state => state.evaluateConfig //评论配置
    }),
    rate() {
      //评价星级
      return Number(this.evaluateResult.evaluateLevel) || 5;
    },
    isSolve() {
      //客户评价状态(已解决/未解决)
      return this.evaluateResult.cusSolveState;
    },
    evaluateStarName() {
      //评价星级库名称
      return this.evaluateResult.evaluateStarName || "后端未返回";
    },
    tags() {
      //评价标签
      const { evaluateTagName, evaluateFlag } = this.evaluateResult;
      return (evaluateFlag && evaluateTagName.split(",")) || [];
    },
    evaluateContent() {
      //评价内容
      return this.evaluateResult.evaluateContent;
    },
    isFiveRate() {
      //是不是五星评价
      return Number(this.evaluateResult.evaluateLevel) === 5;
    },
    isOpenSolveButton() {
      //是否开启解决问题button
      return this.evaluateConfig.solveFlag;
    }
  }
};
</script>

<style lang="less" scoped>
.mobile {
  .comment-success {
    width: 100%;
    height: 25px;
    font-weight: 500;
    margin-top: 31px;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: #29ce42;
    display: flex;
    justify-content: center;
  }
  .solved-button {
    width: 110px;
    height: 36px;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    line-height: 36px;
    margin: 28px auto 0;
    background: var(--evaluate-solve-click);
    color: #1e1e1e;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 4px;
      width: 18px;
    }
  }
  .no-solved-button {
    color: #787878;
    width: 110px;
    height: 36px;
    font-size: 14px;
    background: #f4f4f4;
    border-radius: 5px;
    margin: 28px auto 0;
    line-height: 36px;
    border: 0.5px solid #c5c5c5;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 4px;
      width: 18px;
      height: auto;
    }
  }
  .icon_rate {
    margin-top: 16px;
    height: 40px;
    /deep/ i {
      font-size: 40px;
    }
  }
  .comment-text {
    display: inline-block;
    height: 17px;
    margin-top: 12px;
    font-size: 12px;
    line-height: 17px;
    color: #e39d04;
  }
  .comment-btns {
    display: flex;
    height: auto;
    justify-content: flex-start;
    margin: 20px 0 0px;
    flex-wrap: wrap;

    div {
      width: 159px;
      margin-bottom: 8px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      margin-right: 5px;
      border-radius: 5px;
      background: var(--evaluate-solve-click);

      color: #1e1e1e;
      cursor: pointer;
    }
  }
  .comment-content {
    width: 100%;
    height: auto;
    margin-top: 6px;
    text-align: left;
    font-size: 12px;
    line-height: 17px;
    word-wrap: break-word;
    .pre {
      word-break: break-all;
      text-decoration: none;
      white-space: pre-wrap;
    }
  }
}
.pc {
  .comment-success {
    width: 100%;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    color: var(--evaluate-success-title);
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .solved-button {
    width: 107px;
    height: 36px;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    line-height: 36px;
    margin: 28px auto 0;
    background: var(--evaluate-solve-click);
    color: #1e1e1e;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 4px;
      width: 18px;
    }
  }
  .no-solved-button {
    width: 107px;
    height: 36px;
    font-size: 14px;
    border-radius: 5px;
    margin: 28px auto 0;
    line-height: 36px;
    border: 0.5px solid #c5c5c5;
    background: #f4f4f4;
    color: #787878;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 4px;
      width: 18px;
    }
  }
  .icon_rate {
    margin-top: 33px;
    height: 40px;
    /deep/ i {
      font-size: 40px;
    }
  }
  .comment-text {
    display: inline-block;
    height: 17px;
    font-size: 12px;
    line-height: 17px;
    color: #787878;
  }
  .comment-btns {
    display: flex;
    height: auto;
    justify-content: center;
    margin: 20px 0 10px;
    flex-wrap: wrap;

    div {
      width: 90px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      margin: 5px;
      background: var(--evaluate-solve-click);
      color: #1e1e1e;
      border-radius: 5px;
      cursor: pointer;
    }
    .active {
      background: #2b44b1;
      color: #1e1e1e;
    }
  }
  .comment-content {
    width: 100%;
    height: auto;
    margin-top: 6px;
    text-align: left;
    font-size: 12px;
    line-height: 17px;
    word-wrap: break-word;
    .pre {
      word-break: break-all;
      text-decoration: none;
      white-space: pre-wrap;
    }
  }
}
</style>
